export class Funcionario {
  constructor({
    id,
    nome,
    email,
    sap,
    codIntegracao,
    funcao,
    dataAdmissao,
    cargo,
    centroCustoEPI,
    biometry,
  }) {
    this.id = id;
    this.nome = nome;
    this.email = email;
    this.sap = sap;
    this.codIntegracao = codIntegracao;
    this.funcao = funcao;
    this.dataAdmissao = dataAdmissao;
    this.cargo = cargo;
    this.centroCustoEPI = centroCustoEPI;
    this.biometry = biometry;
  }
}
